import { filterNames } from '@/configuration/components/Filters/constants'

export const filterShippingMethods = (shippingMethods, filters) => {
  const filterKeys = Object.keys(filters)
  if (filterKeys.length === 0) return shippingMethods

  return shippingMethods.filter(shippingMethod => {
    return filterKeys.every(filterName => {
      const filterValue = filters[filterName]

      if (filterName === filterNames.region) {
        const regionsIds = shippingMethod?.regions?.flatMap(region => [
          region.id,
          ...(region?.provinces?.map(province => province.id) || []),
        ])

        return regionsIds?.some(id => filterValue.includes(id))
      }

      if (filterName === filterNames.query && filterValue.length > 0) {
        return shippingMethod.internal_name.toLowerCase().includes(filterValue.toLowerCase())
      }

      if (filterName === filterNames.carrierService) {
        return shippingMethod?.carrier?.id === filterValue
      }

      return true
    })
  })
}
